import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {UserExperienceHttpService} from '../../../services/http-services/user-experience/user-experience-http.service';
import {GrUserExperience} from '../../../services/http-services/user-experience/user-experience-http-interfaces';
import {GetFaqApiDataFormatted} from '../../../services/http-services/faq/faq-http-interfaces';
import {GrFaq} from '../../../interfaces/faq-interfaces';
import {FaqHttpService} from '../../../services/http-services/faq/faq-http.service';
import {FaqEnums} from '../../../enums/faq-enums';
import {GeneralHttpService} from '../../../services/http-services/general/general-http.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DefaultABanners, EmailRegex} from '../../../constants/general-variables';
import {ToastrService} from 'ngx-toastr';
import {BannersHttpService} from '../../../services/http-services/banners/banners-http.service';
import {GrBanner} from '../../../interfaces/banners-interfaces';
import {BlogsHttpService} from '../../../services/http-services/blogs/blogs-http.service';
import {GrBlog} from '../../../interfaces/blogs-interfaces';
import {BlogSectionType} from '../../../enums/blog-enums';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  userExperiences: GrUserExperience[] = [];
  hoveredCategoryBanner?: GrBanner;
  banners: Record<string, GrBanner[]> = {};
  bannerA: GrBanner[] = [];
  blogs: GrBlog[] = [];
  businessPartners = [0, 1, 2];
  faqs: GrFaq[] = [];
  newsletterForm!: FormGroup;
  newsletterFormTriedToSubmit = false;
  activeFaqIndex = 0;
  urlParams: any = {type: FaqEnums.userForDB, search: null};
  homepageVideoUrl: any;
  isPaused = true;
  slideConfig = {
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
  @ViewChild('videoPlayer', { static: false }) videoPlayer!: ElementRef<HTMLVideoElement>;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private userExperienceHttpService: UserExperienceHttpService,
              private generalHttpService: GeneralHttpService,
              private bannersHttpService: BannersHttpService,
              private formBuilder: FormBuilder,
              private toastService: ToastrService,
              private blogsHttpService: BlogsHttpService,
              private faqHttpService: FaqHttpService) {
  }

  ngOnInit(): void {
    this.getBanners();
    this.getUserExperiences();
    this.getFaqs();
    this.getBlogs();
    this.getLandingHomeVideo();
    this.buildForm();
  }

  buildForm(): void {
    this.newsletterForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(EmailRegex)]],
    });
  }

  async getLandingHomeVideo(): Promise<void> {
    try {
      this.homepageVideoUrl = await this.generalHttpService.getLandingHomeVideo();
      setTimeout(() => {
        const video = this.videoPlayer.nativeElement;
        video.muted = true;
        video.play().then(() => {
          video.pause();
          video.currentTime = 0;
        });
      });
    } catch (err) {
      console.error('Failed to load video:', err);
    }
  }

  getBlogs(): void {
    this.blogsHttpService.getBlogsLanding({page: 1}).then(blogsRes => {
      (blogsRes.data.length > 3)
        ? this.blogs = blogsRes.data.slice(3)
        : this.blogs = blogsRes.data;
    });
  }


  getBanners(): void {
    this.bannersHttpService.getLandingWebBanners({bannerTypes: 'a,b,c,d'}).then(res => {
      this.banners = res.data;
      if (this.banners.C.length < 6) {
        this.banners.C = [
          ...this.banners.C,
          ...Array(6 - this.banners.C?.length).fill({ image: {full_path: null}})
        ];
      }
      this.bannerA = DefaultABanners.map((defaultBanner: GrBanner) => {
        const found = this.banners.A?.find(b => b.position === defaultBanner.position);
        return found ? { ...defaultBanner, ...found } : defaultBanner;
      });
      this.hoveredCategoryBanner = this.bannerA[0];
    });
  }

  getFaqs(): void {
    this.faqHttpService.getLandingFaqs({page: 1, ...this.urlParams}).then((res: GetFaqApiDataFormatted) => {
      this.faqs = res.data;
      this.faqHttpService.getLandingFaqs({page: 2, ...this.urlParams}).then((secondRes: GetFaqApiDataFormatted) => {
        this.faqs = [...this.faqs, ...secondRes.data];
      });
    });
  }

  getUserExperiences(): void {
    this.userExperienceHttpService.getLandingUserExperiences().then(res => {
      this.userExperiences = res.data;
    });
  }

  playVideo(): void {
    this.videoPlayer.nativeElement.play();
    this.isPaused = false;
  }

  pauseVideo(): void {
    this.videoPlayer.nativeElement.pause();
    this.isPaused = true;
  }

  onSubmitPostNewsletterForm(): any {
    this.newsletterFormTriedToSubmit = true;
    if (this.newsletterForm.valid) {
      this.generalHttpService.postNewsletter(this.newsletterForm.value).then((res: any) => {
        this.toastService.success(res.message);
        this.newsletterFormTriedToSubmit = false;
        this.newsletterForm.reset();
      }).catch(error => {
        this.toastService.error(error.error.message);
      });
    }
  }

    protected readonly BlogSectionType = BlogSectionType;
}
